import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Diálogo con imagen a pantalla casi completa (Materialoteca: tabla o drawer).
 */
const MaterialotecaPhotoLightbox = ({
  open,
  src,
  alt = "",
  onClose,
  closeAriaLabel,
}) => {
  return (
    <Dialog
      open={Boolean(open && src)}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      slotProps={{
        backdrop: { sx: { bgcolor: "rgba(0,0,0,0.82)" } },
      }}
      PaperProps={{
        sx: {
          bgcolor: "rgba(18,18,18,0.98)",
          backgroundImage: "none",
          boxShadow: "none",
          overflow: "visible",
        },
      }}
    >
      <DialogContent
        sx={{
          position: "relative",
          p: { xs: 1, sm: 2 },
          textAlign: "center",
        }}
      >
        <IconButton
          onClick={onClose}
          aria-label={closeAriaLabel}
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            color: "common.white",
            zIndex: 1,
            bgcolor: "rgba(255,255,255,0.14)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.24)" },
          }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
        {src ? (
          <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
              maxWidth: "100%",
              maxHeight: "min(85vh, 920px)",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              borderRadius: 1,
              display: "inline-block",
              mt: 0.5,
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default MaterialotecaPhotoLightbox;
